import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/login.vue'
import Verbale from "./views/verbale"
import VerbaleSkeleton from "./views/verbaleSkeleton"
import VerbaleSP from "./views/verbaleSP"
import Home from "./views/home"
import Firma from "./views/modificaFirma"
import VerbaleGVR from "./views/verbaleGVR"
import VerbaleGVRIR from "./views/verbaleGVRIR"
import VerbaliRecenti from "./views/verbaliRecenti"
import VerbaleDismissione from "./views/verbaleDismissione"
import VerbaleMRV from "./views/verbaleMRV"
import VerbaleATEX from "./views/verbaleATEX"
import VerbaleSA from "./views/verbaleSA"
import VerbaleTERRE from "./views/verbaleTERRE"
import WindowTest from "./views/windowsTest.vue"
import RicercaVerbale from "./views/ricercaVerbale.vue"
import Veicoli from "./views/veicoli.vue"
import PianificazioneAttivita from "./views/pianificazioneAttivita.vue"
import GoogleMaps from "./views/googleMaps.vue"
import Smartcal from "./views/smartcal.vue"
import ScadenziarioVerificheRidotto from "./views/scadenziarioVerificheRidotto.vue"
import Straordinari from './views/straordinari.vue'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [{
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: "/verbale",
      name: "verbale",
      component: Verbale
    },
    {
      path:"/verbaleSPSC",
      name:"verbaleSP",
      component:VerbaleSP,
    },
    {
      path: "/verbaleSkeleton",
      name: "verbaleSkeleton",
      component: VerbaleSkeleton
    },{
      path:"/",
      name:"Home",
      component:Home
    },
    {
      path:"/firma",
      name:"firma",
      component:Firma
    },
    {
      path:"/verbaleGVR",
      name:"Verbale GVR",
      component:VerbaleGVR
    },
    {
      path:"/verbaleGVRIR",
      name: "Verbale GVRIR",
      component:VerbaleGVRIR
    },
    {
      path:"/recenti",
      name: "Verbali recenti",
      component:VerbaliRecenti
    },
    {
      path:"/verbaleDismissione",
      name: "Verbale dismissione",
      component:VerbaleDismissione
    },
    {
      path:"/windowTest",
      name: "WindowTest",
      component:WindowTest
    },
    {
      path:"/verbaleMRV",
      name: "verbaleMRV",
      component:VerbaleMRV
    },
    {
      path:"/verbaleATEX",
      name: "verbaleATEX",
      component:VerbaleATEX
    },
    {
      path:"/verbaleSA",
      name: "verbaleSA",
      component:VerbaleSA
    },
    {
      path:"/verbaleTERRE",
      name: "verbaleTERRE",
      component:VerbaleTERRE
    },
    {
      path:"/veicoli",
      name: "Veicoli",
      component: Veicoli
    },
    {
      path:"/ricercaVerbale",
      name: "Ricerca Verbale",
      component: RicercaVerbale
    },
    {
      path:"/pianificazioneAttivita",
      name: "Pianificazione Attività",
      component: PianificazioneAttivita
    },
    {
      path:"/googleMaps",
      name: "Google Maps",
      component: GoogleMaps
    },
    {
      path:"/smartcal",
      name: "Smartcal",
      component: Smartcal
    },
    {
      path:"/scadenziarioVerificheRidotto",
      name: "Scadenziario Verifiche Ridotto",
      component: ScadenziarioVerificheRidotto
    },
    {
      path:"/straordinari",
      name: "Straordinari",
      component: Straordinari
    }
  ]
})